import { sv } from "@dhx/ts-common/dom";
import spline from "../helpers/spline";
import { PointData } from "../types";
import Line from "./Line";

export default class Spline extends Line {
	protected _getForm(points: PointData[], config: any, css: string, width: number, height: number): object {
		const { color } = config;
		const className = config.css;
		const d = spline(points);
		return sv("path", {
			id: "seria" + config.id,
			d,
			class: className,
			stroke: color,
			"stroke-width": 2,
			fill: "none",
		});
	}
}
